import React from 'react';
import PropTypes from 'prop-types';
import SelectMultiple from '../../../common/SelectMultiple';

const SelectMultipleField = ({ name, options, label, wrapperClass }) => (
  <div className={wrapperClass}>
    <div className="c-label-new">{ label }</div>
    <SelectMultiple name={name} options={options} />
  </div>
);
SelectMultipleField.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  wrapperClass: PropTypes.string,
};
SelectMultipleField.defaultProps = {
  label: 'Select Fields',
  wrapperClass: 'layout__item u-1/2-medium-and-up',
};

export default SelectMultipleField;
